import React from "react"

import Banner from "../banner"
import Gallery from "./event-gallery"

const EventSections = ({ props }) => {
  const { sections } = props
  const sectionsLength = sections.length
  if (!sections || !sectionsLength) {
    return null
  }
  let mobileIndex = -1
  return (
    <>
      {sections.map((section, index) => {
        const fieldGroupName = section?.fieldGroupName
        if (section.hideOnMobile !== true) { mobileIndex++ }
        if (fieldGroupName) {
          return fieldGroupName.includes("Sections_Banner") ? (
            <Banner props={{ ...section, background: index % 2 === 1 ? "white" : "lightGray" }} index={index} noFlip={index === 0} key={index}  mobileIndex={mobileIndex} />
          ) : fieldGroupName.includes("Sections_Gallery") ? (
            <Gallery props={section} key={index} index={index} isCarousel={false} isWide={true} />
          ) : null
        } else {
          return null
        }
      })}
    </>
  )
}

export default EventSections
